// extracted by mini-css-extract-plugin
export var eyebrow = "_bz-3";
export var heroImage = "_bz-4";
export var main = "_bz-2";
export var modal = "_bz-0";
export var shell = "_bz-1";